import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import fetcher, { loadingStatus } from "helpers/fetcher";
import { displayCategoryName } from "helpers";
import { raw } from "constants/endpoints";

const mapCategoryNames = categories =>
  (categories || []).map(cat => ({
    ...cat,
    name: displayCategoryName(cat.name),
    label: displayCategoryName(cat.label),
    title: displayCategoryName(cat.title),
    children: cat.children ? mapCategoryNames(cat.children) : cat.children,
  }));

const fetchCategoriesList = createAsyncThunk("menu.CATEGORIES_LIST", async () => {
  const response = await fetcher(raw.CATEGORIES_LIST);
  return response.json();
});

const initialState = {
  categoriesList: {
    data: {},
    status: loadingStatus.IDLE,
  },
};

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchCategoriesList.pending, (state, action) => {
        state.categoriesList.status = loadingStatus.LOADING;
      })
      .addCase(fetchCategoriesList.fulfilled, (state, action) => {
        state.categoriesList.status = loadingStatus.SUCCEEDED;
        const data = action.payload || {};
        state.categoriesList.data = data.categories
          ? { ...data, categories: mapCategoryNames(data.categories) }
          : data;
      })
  }
});

export default menuSlice.reducer;

// export const { postAdded, postUpdated, reactionAdded } = playerSlice.actions;
export {
  fetchCategoriesList,
};
